export default "__VITE_ASSET__UL$Mrc9y__"